import './style.less';
import * as React from 'react';
import { Spinner } from '@components/spinner';
import { ServerErrorWithCloud } from '@components/server-error-with-cloud/server-error';

const { useState, useEffect } = React;

interface IPageLoadingIndicatorProps {
    error: boolean;
}

export const PageLoadingIndicator: React.FC<IPageLoadingIndicatorProps> = (props) => {
    const { error } = props;
    const [isLoading, setIsLoading] = useState(true);

    const tryAgain = () => {
        return window.location.reload();
    };

    const renderPageLoadError = () => {
        return (
            <div className="tc-srm">
                <div className="tc-srm-page-loader">
                    {/* eslint-disable-next-line react/jsx-no-bind */}
                    <ServerErrorWithCloud tryAgain={tryAgain} />
                </div>
            </div>
        );
    };

    useEffect(() => {
        return () => setIsLoading(false);
    }, []);

    if (error) {
        return renderPageLoadError();
    }

    return <Spinner show={isLoading} />;
};
